export const isFromPageReload = (): boolean => {
  if (typeof performance?.getEntriesByType !== 'function') {
    return false;
  }

  return (
    (performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming)
      ?.type === 'reload'
  );
};
